import React, { useState } from 'react';
import './CheckCertification.css';
import HeaderInsideFooter from './HeaderInsideFooter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

const CheckCertification = () => {
  const [certificationId, setCertificationId] = useState('');
  const [activeCertifications, setActiveCertifications] = useState([]);

  const handleSearch = () => {
    // Logic pentru cautare certificare
    console.log('Searching for:', certificationId);
  };

  return (
    <div className='check-certification-page'>
      <HeaderInsideFooter />
      
      <div className='certification-content'>
        <div className='certification-left'>
          <div className='certification-search-section'>
            <h1 className='certification-title'>Cautare Certificat</h1>
            
            <div className='certification-search-box'>
              <input
                type='text'
                className='certification-input'
                placeholder='FFFFFF-FFFFFF'
                value={certificationId}
                onChange={(e) => setCertificationId(e.target.value)}
              />
              <FontAwesomeIcon 
                icon={faSearch} 
                className='certification-search-icon'
                onClick={handleSearch}
              />
            </div>
            
            <p className='certification-note'>
              * ID-ul certificatului este localizat in partea de jos a certificatului
            </p>

            <div className='my-certifications-section'>
              <h2 className='my-certifications-title'>Certificatele mele</h2>
              {activeCertifications.length === 0 ? (
                <p className='no-certifications'>Nicio certificare activa.</p>
              ) : (
                <div className='certifications-list'>
                  {activeCertifications.map((cert, index) => (
                    <div key={index} className='certification-item'>
                      {cert.name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className='certification-right'>
          <div className='certification-info-section'>
            <h3 className='info-question'>Cum obtin o certificare ContaLearn?</h3>
            <p className='info-answer'>
              Completeaza o sectiune de curs sau un curs eligibil pe ContaLearn.
            </p>

            <h3 className='info-question'>De ce ar trebui sa obtii o certificare ContaLearn?</h3>
            <p className='info-answer'>
              Evidentiaza-te in fata angajatorilor demonstrand abilitatile tale practice in contabilitate cu certificarea ContaLearn.
              Valideaza expertiza ta, atrage recruiteri si poate creste potentialul tau de castig.
            </p>

            <h3 className='info-question'>Poate fi afisata pe LinkedIn sau alta platforma?</h3>
            <p className='info-answer'>
              Desigur, este simplu! Ti se furnizeaza un link URL, format PDF si un ID de certificare, 
              pe care le poti distribui oriunde pentru a prezenta certificarea ta activa.
            </p>

            <h3 className='info-question'>Iata un exemplu de certificare ContaLearn</h3>
            <div className='certificate-example'>
              <div className='certificate-frame'>
                <div className='certificate-header-text'>CERTIFICATE OF COMPLETION</div>
                <div className='certificate-subtitle'>This is to certify that</div>
                <div className='certificate-name'>Ion Popescu</div>
                <div className='certificate-completed'>has completed the course</div>
                <div className='certificate-course'>Bazele Contabilitatii</div>
                <div className='certificate-footer'>
                  <div className='certificate-signature'>
                    <div className='signature-line'></div>
                    <p>Instructor, ContaLearn</p>
                  </div>
                  <div className='certificate-logo'>📜</div>
                  <div className='certificate-date'>
                    <p>Feb 21, 2026</p>
                    <p>Date</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckCertification;
